export function calculateTradingPairs(tradeableAssets) {
  if (tradeableAssets < 2) return 0; // there are no combinations if n is less than 2
  return (tradeableAssets * (tradeableAssets - 1)) / 2;
}
